// import "./App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider } from 'contexts/AuthContext';
import { CollapseDrawerProvider } from 'contexts/CollapseDrawerContext';
import { Provider as ReduxProvider } from 'react-redux';
import { store } from 'redux/store';
import Router from 'routes';
import ThemeSetter from './theme/ThemeSetter';
function App() {
  return (
    <AuthProvider>
      <ReduxProvider store={store}>
        <CollapseDrawerProvider>
          <ThemeSetter>
            <Router />
          </ThemeSetter>
        </CollapseDrawerProvider>
      </ReduxProvider>
    </AuthProvider>
  );
}

export default App;
